export default {

    data() {
        return {
            gebr: [],        
        }   
    },
    methods: {
        getGebr() {
            this.$axios
                .post("ares/json/ares/huov/hosm/getGebr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getGebr"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.gebr = res.data.getGebr;
                    }
                }); 
        }
    }
}